;(function() {
  'use strict'

  angular.module('app.survey').component('surveyQuestionScan', {
    controller: Controller,
    templateUrl: 'survey-question-scan.html',
    bindings: {
      survey: '<',
      question: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.onBarcodeScanned = onBarcodeScanned

    function onInit() {
      ctrl.canScan = !!(navigator && navigator.mediaDevices)
    }

    function onBarcodeScanned(barcode) {
      ctrl.question.text = barcode
      ctrl.scannerVisible = false
    }
  }
})()
